import React, { useEffect, useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import instance from '../../services/baseService';


const SheetSubmitSkipModal = ({ showSkipModal, handleSkipClose,  handleSkipSubmit,currentAction}) => {
    const [selectedOption, setSelectedOption] = useState('');
    const [validated, setValidated] = useState(false);

    const handleSubmit = async () => {
        try {
            if (!selectedOption) {
                setValidated(true); // Show validation error if no option is selected
            } else {
                await handleSkipSubmit(selectedOption); // Close the modal after submission
                handleSkipClose();
            }
        } catch (error) {
            console.error("Error submitting data:", error);
            // Handle error appropriately
        }
    };

    return (
        <Modal show={showSkipModal} onHide={handleSkipClose} enforceFocus={false} backdrop="static" id="skip-modal" className='border-0'>
            <Modal.Header closeButton>
                <Modal.Title>Skip Submission</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form noValidate validated={validated}>
                    <Form.Group controlId="formSelect">
                        <Form.Label>Select user category</Form.Label>
                        <Form.Control
                            as="select"
                            value={selectedOption}
                            onChange={(e) => setSelectedOption(e.target.value)} // Handle change
                            isInvalid={validated && !selectedOption}
                        >
                            <option value="">Select Role...</option> {/* Default empty option */}
                            {(currentAction?.highest_role || []).map((option) => (
                            <option key={option?.id} value={option?.id}>
                                {option?.name}
                            </option>
                            ))}
                        </Form.Control>
                        <Form.Control.Feedback type="invalid">
                            Please select an option.
                        </Form.Control.Feedback>
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="outline-primary" onClick={handleSkipClose} className='no-hover fw-bold' style={{width:"100px"}}>
                    Close
                </Button>
                <Button variant="primary" onClick={handleSubmit} style={{width:"100px"}} className='fw-bold'>
                    Submit
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default SheetSubmitSkipModal;